module.exports = __webpack_public_path__ + "static/media/Mask Group 176.d67f3f6e.svg";